/**
 * Created by sagardesai on 10/07/18.
 */

import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    followersList: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.FOLLOWERS_LIST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.FOLLOWERS_LIST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                followersList: action.payload
            };
        case types.FOLLOWERS_LIST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                followersList: action.payload.error,
            };
        case types.RESET_FOLLOWERS_LIST:
            return {
                ...state,
                followersList: action.payload,
            };
        case types.SET_SEARCH_FOLLOWERS_STATE:
            return {
                ...state,
                performSearch: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}